import { createElement } from "react";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { collect, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { t } from "../Lang.js";
import { Account_title, Common_cancel, Account_deleteAccount, Account_deleting, Account_typeDelete, Account_deleteWarning, Account_dangerZone, Account_noConnectedAccounts, Account_connectedAccounts, Account_passwordChanged, Account_passwordSet, Account_confirmPassword, Account_newPassword, Account_currentPassword, Account_setPasswordHint, Account_changePassword, Account_setPassword, Account_saveProfile, Account_saving, Account_profileUpdated, Account_emailReadOnly, Account_email, Account_name, Account_profile } from "../Shared/Tr.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isEmpty, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.28.0/String.js";

function profileSection(form, email, dispatch) {
    let elems_3;
    return createElement("div", createObj(ofArray([["className", "card account-section"], (elems_3 = toList(delay(() => append(singleton(createElement("h3", {
        children: t(Account_profile),
    })), delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
            children: t(Account_name),
        }), createElement("input", {
            className: "form-input",
            type: "text",
            value: form.Name,
            onChange: (ev) => {
                dispatch(new Msg(216, [ev.target.value]));
            },
            disabled: form.IsSubmittingProfile,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Account_email),
            }), createElement("input", {
                className: "form-input",
                type: "email",
                value: email,
                disabled: true,
            }), createElement("small", {
                className: "form-hint",
                children: t(Account_emailReadOnly),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let matchValue;
                return append((matchValue = form.ProfileError, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
                    className: "error-message",
                    children: matchValue,
                }))), delay(() => append(form.ProfileSuccess ? singleton(createElement("div", {
                    className: "success-message",
                    children: t(Account_profileUpdated),
                })) : empty(), delay(() => {
                    let elems_2;
                    return singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("button", {
                        className: "btn btn-primary",
                        disabled: form.IsSubmittingProfile ? true : (form.Name.trim() === ""),
                        children: form.IsSubmittingProfile ? t(Account_saving) : t(Account_saveProfile),
                        onClick: (_arg) => {
                            if (!form.IsSubmittingProfile) {
                                dispatch(new Msg(217, []));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }))));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function passwordSection(form, dispatch) {
    let elems_4;
    const isSetMode = !form.HasPassword;
    return createElement("div", createObj(ofArray([["className", "card account-section"], (elems_4 = toList(delay(() => append(singleton(createElement("h3", {
        children: isSetMode ? t(Account_setPassword) : t(Account_changePassword),
    })), delay(() => append(isSetMode ? singleton(createElement("p", {
        className: "form-hint",
        children: t(Account_setPasswordHint),
    })) : empty(), delay(() => {
        let elems;
        return append(form.HasPassword ? singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
            children: t(Account_currentPassword),
        }), createElement("input", {
            className: "form-input",
            type: "password",
            value: form.CurrentPassword,
            onChange: (ev) => {
                dispatch(new Msg(219, [ev.target.value]));
            },
            disabled: form.IsSubmittingPassword,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Account_newPassword),
            }), createElement("input", {
                className: "form-input",
                type: "password",
                value: form.NewPassword,
                onChange: (ev_1) => {
                    dispatch(new Msg(220, [ev_1.target.value]));
                },
                disabled: form.IsSubmittingPassword,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                    children: t(Account_confirmPassword),
                }), createElement("input", {
                    className: "form-input",
                    type: "password",
                    value: form.ConfirmPassword,
                    onChange: (ev_2) => {
                        dispatch(new Msg(221, [ev_2.target.value]));
                    },
                    disabled: form.IsSubmittingPassword,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let matchValue;
                    return append((matchValue = form.PasswordError, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
                        className: "error-message",
                        children: matchValue,
                    }))), delay(() => append(form.PasswordSuccess ? singleton(createElement("div", {
                        className: "success-message",
                        children: isSetMode ? t(Account_passwordSet) : t(Account_passwordChanged),
                    })) : empty(), delay(() => {
                        let elems_3;
                        return singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("button", {
                            className: "btn btn-primary",
                            disabled: (form.IsSubmittingPassword ? true : (form.NewPassword === "")) ? true : (form.ConfirmPassword === ""),
                            children: form.IsSubmittingPassword ? t(Account_saving) : (isSetMode ? t(Account_setPassword) : t(Account_changePassword)),
                            onClick: (_arg) => {
                                if (!form.IsSubmittingPassword) {
                                    dispatch(new Msg(222, []));
                                }
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }))));
                }));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function connectedAccountsSection(form) {
    let elems_1;
    return createElement("div", createObj(ofArray([["className", "card account-section"], (elems_1 = toList(delay(() => append(singleton(createElement("h3", {
        children: t(Account_connectedAccounts),
    })), delay(() => {
        let elems;
        return isEmpty(form.ConnectedProviders) ? singleton(createElement("p", {
            className: "form-hint",
            children: t(Account_noConnectedAccounts),
        })) : singleton(createElement("ul", createObj(ofArray([["className", "connected-providers-list"], (elems = toList(delay(() => collect((matchValue) => {
            const providerId = matchValue[0];
            return singleton(createElement("li", {
                key: providerId,
                className: toText(printf("provider-item provider-%s"))(providerId),
                children: matchValue[1],
            }));
        }, form.ConnectedProviders))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function dangerZoneSection(form, dispatch) {
    let elems_2;
    return createElement("div", createObj(ofArray([["className", "card account-section danger-zone"], (elems_2 = toList(delay(() => append(singleton(createElement("h3", {
        children: t(Account_dangerZone),
    })), delay(() => (form.ShowDeleteConfirm ? append(singleton(createElement("p", {
        className: "danger-warning",
        children: t(Account_deleteWarning),
    })), delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
            children: t(Account_typeDelete),
        }), createElement("input", {
            className: "form-input",
            type: "text",
            value: form.DeleteConfirmText,
            onChange: (ev) => {
                dispatch(new Msg(225, [ev.target.value]));
            },
            disabled: form.IsSubmittingDelete,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return singleton(createElement("div", createObj(ofArray([["className", "form-group form-actions"], (elems_1 = [createElement("button", {
                className: "btn btn-danger",
                disabled: form.IsSubmittingDelete ? true : (form.DeleteConfirmText !== "DELETE"),
                children: form.IsSubmittingDelete ? t(Account_deleting) : t(Account_deleteAccount),
                onClick: (_arg) => {
                    if (!form.IsSubmittingDelete && (form.DeleteConfirmText === "DELETE")) {
                        dispatch(new Msg(226, []));
                    }
                },
            }), createElement("button", {
                className: "btn btn-secondary",
                disabled: form.IsSubmittingDelete,
                children: t(Common_cancel),
                onClick: (_arg_1) => {
                    dispatch(new Msg(224, []));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }));
    })) : singleton(createElement("button", {
        className: "btn btn-danger",
        children: t(Account_deleteAccount),
        onClick: (_arg_2) => {
            dispatch(new Msg(224, []));
        },
    }))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function view(model, dispatch) {
    let elems;
    const form = model.AccountForm;
    let email;
    const matchValue = model.CurrentUser;
    email = ((matchValue == null) ? "" : matchValue.Email);
    return createElement("div", createObj(ofArray([["className", "account-container"], (elems = [createElement("h2", {
        children: t(Account_title),
    }), profileSection(form, email, dispatch), passwordSection(form, dispatch), connectedAccountsSection(form), dangerZoneSection(form, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

